import { FLASHCARDS_EDITOR_CLASSNAME } from "@/components/flashcards/flashcardsCard/EditableFlashcardCard/constants";
import { unwrapFromParagraph } from "@/components/FullPageEditor/utils/contentParser";

export const generateFlashcardCardId = (flashcardId: string) => {
    return `flashcardCard-${flashcardId}`;
};

export const queryEditableFlashcardCard = (flashcardId: string) => {
    return document.getElementById(generateFlashcardCardId(flashcardId));
};

export const queryTermTextArea = (editableFlashcardCardElement?: Element) => {
    return editableFlashcardCardElement?.getElementsByClassName(FLASHCARDS_EDITOR_CLASSNAME)?.[0] as HTMLInputElement;
};

export const queryFlashcardTextArea = (editableFlashcardCardElement?: Element) => {
    return editableFlashcardCardElement?.getElementsByClassName(FLASHCARDS_EDITOR_CLASSNAME)?.[1];
};

export const isFlashcardCardEmpty = ({ term, definition }: { term: string; definition: string }) =>
    !unwrapFromParagraph(term) && !unwrapFromParagraph(definition);

/** make sure if there are two paragraphs, we separate them with newline (<br/>) */
const addNewLineInParagraphs = (text: string) => {
    return text.replace(/<\/p><p>/g, "</p><br/><br/><p>");
};

export const mergeTermAndDefinitionText = ({
    term,
    definition,
    index,
}: {
    term: string;
    definition: string;
    index?: number;
}) => {
    const stripTerm = unwrapFromParagraph(addNewLineInParagraphs(term));
    const stripDefinition = unwrapFromParagraph(addNewLineInParagraphs(definition));

    if (!stripTerm && !stripDefinition && typeof index === "number") {
        return `Flashcard ${index + 1} selected`;
    }

    const termHtml = "<strong>" + stripTerm + "</strong>";
    const dash = " - ";
    const definitionHtml = stripDefinition;

    const textHtml = termHtml + dash + definitionHtml;

    return textHtml;
};
